/**
 * Created by vikash on 13/05/16.
 */
'use strict';
moduleConfig.registerModule('dtmService.module', []);